import { Theme } from "@mui/material";

const useStyles = (theme: Theme, metrics: Object) => {
  const legendSx = {};

  return {
    sx: {
      mt: 2,
      p: 1,
      maxHeight: 100, // altura máxima da legenda
      overflowY: "auto",
      flexWrap: "wrap",
      display: "flex",
      gap: 1,
      ...("right" in legendSx ? { right: legendSx?.right } : { left: 0 }),
      ...("top" in legendSx ? { top: legendSx?.top } : { bottom: 0 }),
    },
    contentSx: (
      direction: "row" | "column",
      position: "start" | "end" | "left" | "right" | "center",
      gap: number
    ) => ({
      display: "flex",
      containerType: "size",
      gap,
      //paddingX: 3,
      flexDirection: direction,
      alignItems: "start",
      justifyContent: position,
      ...(direction === "column" && { height: "100%", width: "200px" }),
      ...(direction === "row" && {
        width: "100%",
        height: "100%",
      }),
      overflowX: "hidden",
      overflowY: "auto",
      flexWrap: "wrap",
      // backgroundColor: "red",
    }),
    contentChildSx: (variant: string) => ({
      display: "flex",
      justifyContent: "start",
      alignItems: "start",
      flexDirection: "row",
      height: "fit-content",
      gap: 1.5,
      ...(variant === "block" ? { width: "100%" } : {}),
    }),
    textSx: {
      fontSize: 14,
      // fontWeight: "bold",
      transition: "color 0.3s ease",
      cursor: "pointer",
      overflowWrap: "break-word",
      wordWrap: "break-word",
      wordBreak: "break-word",
      whiteSpace: "normal",
      // whiteSpace: "nowrap",
      color: theme.palette.text.primary,
      "&:hover": {
        opacity: 0.8,
      },
    },
    symbolSx: (backgroundColor?: string) => ({
      width: Object.keys(metrics).length > 0 ? 4 : 10,
      height: Object.keys(metrics).length > 0 ? 18 : 10,
      borderRadius: Object.keys(metrics).length > 0 ? "30px" : "50%",
      backgroundColor: backgroundColor ?? "#OOO",
      flexShrink: 0,
    }),
    textTypography: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
  };
};

export default useStyles;
